import type { SVGProps } from 'react';

export const FacebookIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M12 21c4.97 0 9-4.03 9-9s-4.03-9-9-9-9 4.03-9 9 4.03 9 9 9Z" />
    <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M15.75 8.25H14.25A2.25 2.25 0 0 0 12 10.5V21" />
    <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M9 13.5h6" />
  </svg>
);

export const XIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M4.5 3.75H9l10.5 16.5H15L4.5 3.75Z" />
    <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M10.676 13.456 4.5 20.25" />
    <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M19.5 3.75l-6.176 6.794" />
  </svg>
);

export const LinkedInIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M20.25 3H3.75A.75.75 0 0 0 3 3.75v16.5c0 .414.336.75.75.75h16.5a.75.75 0 0 0 .75-.75V3.75A.75.75 0 0 0 20.25 3Z" />
    <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M11.25 10.5v6M8.25 10.5v6" />
    <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M11.25 13.125a2.625 2.625 0 0 1 5.25 0V16.5" />
    <path fill="currentColor" d="M8.25 9a1.125 1.125 0 1 0 0-2.25A1.125 1.125 0 0 0 8.25 9Z" />
  </svg>
);

export const TelegramIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M7.5 12.644 15.962 20.063a.75.75 0 0 0 1.227-.572L21 3.114a.12.12 0 0 0-.126-.12L1.875 10.442a.75.75 0 0 0 .094 1.407L7.5 12.644Z" />
    <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M7.5 12.644 20.945 3.008" />
    <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="m11.66 16.292-2.87 2.977A.75.75 0 0 1 7.5 18.75v-6.106" />
  </svg>
);

export const CopyIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18" {...props}>
    <path stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" d="M11.813 11.813h3.374V2.813H6.188v3.374" />
    <path stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" d="M11.813 6.188H2.813v9h9v-9Z" />
  </svg>
);
